export default {"src":"/_next/static/media/Rupee.0eb241bd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};